(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kf-product-status"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-kf-product-status]';
    let timer;
    const expire = () => {
      clearTimeout(timer);
      const now = Date.now();
      let next = Infinity;
      document.querySelectorAll(selector).forEach(label => {
        const start = Number(label.dataset.statusStart) * 1000;
        const end = Number(label.dataset.statusEnd) * 1000;
        if (!Number.isFinite(start) || !Number.isFinite(end) || start <= 0 || end <= start || now < start || now >= end) {
          label.hidden = true;
          return;
        }
        next = Math.min(next, end - now);
      });
      if (Number.isFinite(next)) timer = setTimeout(expire, Math.max(1, Math.min(next, 60000)));
    };
    const init = () => {
      const grid = document.querySelector('#product-grid');
      if (!grid) return;
      expire();
      new MutationObserver(changes => {
        if (changes.some(change => [...change.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) expire();
      }).observe(grid, {childList: true, subtree: true});
      document.addEventListener('visibilitychange', () => { if (!document.hidden) expire(); });
      window.addEventListener('pageshow', expire);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kf-search-header-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kf-header-search')) {
    customElements.define('kf-header-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.shell = this.closest('page-header');
        this.input = this.querySelector('.kf-search__input');
        this.desktop = window.matchMedia('(min-width: 1200px)');
        const options = { signal: this.events.signal };
        this.shell.addEventListener('click', (event) => {
          if (!event.target.closest('.kf-search-toggle') || !this.desktop.matches) return;
          event.preventDefault();
          if (this.hidden) this.open();
          else this.close(true);
        }, options);
        this.querySelector('.kf-header-search__close').addEventListener('click', () => this.close(true), options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.hidden) {
            event.preventDefault();
            this.close(true);
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.hidden && !this.contains(event.target) && !this.trigger?.contains(event.target)) this.close();
        }, options);
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target) && !this.trigger?.contains(event.target)) this.close();
        }, options);
        const update = () => {
          if (!this.desktop.matches && !this.hidden) {
            const hadFocus = this.contains(document.activeElement);
            this.close();
            if (hadFocus) this.shell.querySelector('.kf-inline-search .kf-search__input')?.focus();
          } else if (!this.hidden) {
            this.updateHeight();
          }
        };
        window.addEventListener('resize', update, options);
        window.addEventListener('scroll', update, { ...options, passive: true });
        window.visualViewport?.addEventListener('resize', update, options);
      }

      get trigger() {
        return this.shell?.querySelector('.kf-search-toggle');
      }

      open() {
        if (!this.desktop.matches) return;
        this.shell.querySelectorAll('.kf-inline-search kf-search').forEach((search) => search.close?.());
        this.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.updateHeight();
        this.input.focus({ preventScroll: true });
      }

      updateHeight() {
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        this.style.setProperty('--kf-header-search-height', `${Math.max(0, bottom - this.getBoundingClientRect().top - 16)}px`);
      }

      close(restoreFocus = false) {
        this.hidden = true;
        this.querySelector('kf-search')?.close?.();
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger?.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        this.close();
        this.events?.abort();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kf-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kf-search')) {
    customElements.define('kf-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.input = this.querySelector('.kf-search__input');
        this.form = this.querySelector('form');
        this.panel = this.querySelector('.kf-search__panel');
        this.results = this.querySelector('.kf-search__results');
        this.status = this.querySelector('.kf-search__status');
        this.all = this.querySelector('.kf-search__all');
        this.services = [...this.querySelectorAll('[data-kf-service-terms]')];
        try {
          this.categories = JSON.parse(this.querySelector('[data-kf-search-categories]')?.textContent || '[]');
        } catch {
          this.categories = [];
        }
        this.sequence = 0;
        this.redirectColorSearch();
        const options = { signal: this.events.signal };
        this.input.addEventListener('input', (event) => {
          if (!event.isComposing && !this.composing) this.search();
        }, options);
        this.input.addEventListener('compositionstart', () => {
          this.composing = true;
          this.close();
        }, options);
        this.input.addEventListener('compositionend', () => {
          this.composing = false;
          this.search();
        }, options);
        this.input.addEventListener('focus', () => this.search(), options);
        this.form.addEventListener('submit', (event) => {
          this.input.value = this.normalizeTerm(this.input.value);
          if (!this.input.value || this.composing) {
            event.preventDefault();
          } else {
            const filteredUrl = this.colorCategoryUrl(this.input.value);
            if (filteredUrl) {
              event.preventDefault();
              location.assign(filteredUrl.href);
            }
          }
          this.close();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            if (this.input !== document.activeElement) {
              this.suppressFocus = true;
              this.input.focus();
              this.suppressFocus = false;
            }
          }
          if (event.target === this.input && !this.panel.hidden && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
            const links = [...this.panel.querySelectorAll('a')].filter((el) => !el.hidden);
            event.preventDefault();
            (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
          }
        }, options);
        this.querySelector('.kf-search__dismiss').addEventListener('click', () => {
          this.close();
          this.suppressFocus = true;
          this.input.focus();
          this.suppressFocus = false;
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target)) this.close();
        }, options);
      }

      disconnectedCallback() {
        this.close();
        this.events?.abort();
        this.events = null;
      }

      cancel() {
        this.sequence += 1;
        clearTimeout(this.timer);
        clearTimeout(this.deadline);
        this.request?.abort();
        this.request = null;
        this.results?.removeAttribute('aria-busy');
      }

      close() {
        this.cancel();
        if (!this.panel) return;
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.status.textContent = '';
      }

      message(text) {
        const paragraph = document.createElement('p');
        paragraph.className = 'kf-search__message';
        paragraph.textContent = text;
        this.results.replaceChildren(paragraph);
        this.status.textContent = text;
      }

      normalizeTerm(value) {
        const term = value.trim().replace(/\s+/g, ' ');
        // Keep explicit Shopify search syntax and quoted model names intact.
        if (/[":*()|]/.test(term) || /\b(?:AND|OR|NOT)\b/.test(term)) return term;
        return term
          .replace(/(^|\s)(?:strickpullis?|strickpullover|strick pullis?|strick pullover)(?=\s|$)/gi, '$1strick-pullover')
          .replace(/(^|\s)(?:karo|kariert(?:e|en|er|es)?|karo[ -]muster)(?=\s|$)/gi, '$1karomuster');
      }

      normalizeServiceTerm(value) {
        if (/[":*|]/.test(value)) return '';
        return value.toLowerCase()
          .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/œ/g, 'oe').replace(/æ/g, 'ae')
          .replace(/[éèêë]/g, 'e').replace(/[àâá]/g, 'a').replace(/[òóô]/g, 'o').replace(/[ìíîï]/g, 'i').replace(/[ùúû]/g, 'u').replace(/ç/g, 'c').replace(/[ÿý]/g, 'y')
          .replace(/[-.,?!:;\/()'’&–—]/g, ' ').trim().replace(/\s+/g, ' ');
      }

      serviceNearMatch(query, keyword) {
        // Keep this bounded whole-phrase comparison in sync with kf-search-one-edit.
        if (query.length < 4 || query.length > 48 || keyword.length < 5 || keyword.length > 48 || Math.abs(query.length - keyword.length) > 1) return false;
        let prefix = 0;
        while (prefix < query.length && query[prefix] === keyword[prefix]) prefix++;
        if (query.length > keyword.length) return query.slice(prefix + 1) === keyword.slice(prefix);
        if (query.length < keyword.length) return query.slice(prefix) === keyword.slice(prefix + 1);
        return query.slice(prefix + 1) === keyword.slice(prefix + 1)
          || (query[prefix] === keyword[prefix + 1] && query[prefix + 1] === keyword[prefix] && query.slice(prefix + 2) === keyword.slice(prefix + 2));
      }

      matchingServices(term) {
        const normalized = this.normalizeServiceTerm(term);
        if (!normalized) return [];
        const phrase = ' ' + normalized + ' ';
        const entries = this.services.map((service) => ({ service, keywords: service.dataset.kfServiceTerms.split(',') }));
        const exact = entries.filter(({ keywords }) => keywords.some((keyword) => keyword && phrase.includes(' ' + keyword + ' ')));
        if (exact.length) return exact.map(({ service }) => service);
        const query = normalized.replace(/ /g, '');
        if (query.length < 4 || query.length > 48) return [];
        const compact = entries.map(({ service, keywords }) => ({ service, keywords: keywords.map((keyword) => keyword.replace(/ /g, '')).filter((keyword) => keyword.length >= 5 && keyword.length <= 48) }));
        const spacing = compact.filter(({ keywords }) => keywords.includes(query));
        if (spacing.length) return spacing.map(({ service }) => service);
        return compact.filter(({ keywords }) => keywords.some((keyword) => this.serviceNearMatch(query, keyword))).map(({ service }) => service);
      }

      isBlockedSearch(term) {
        if (term.toLowerCase().includes('vegan')) return true;
        const normalized = ' ' + term.toLowerCase()
          .replace(/[²₂]/g, '2')
          .replace(/[-–—‐‑®™&.,:;/\\()[\]{}!?"'’‘“”„+*=<>_#%|]/g, ' ')
          .replace(/\s+/g, ' ').trim() + ' ';
        return this.dataset.blockedSearchTerms.split('|').some((rule) => {
          if (!rule) return false;
          const match = ' ' + rule.replace(/\*/g, '') + (rule.endsWith('*') ? '' : ' ');
          return normalized.includes(match);
        });
      }

      colorCategoryUrl(term) {
        if (this.isBlockedSearch(term)) return null;
        if (/[":*()|]/.test(term)) return null;
        const normalize = (value) => value.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/-/g, ' ').trim().replace(/\s+/g, ' ');
        const colors = [
          [/^(rot(?:e|en|er|es|em)?|red)$/, ['Red', 'Rot']],
          [/^(schwarz(?:e|en|er|es|em)?|black)$/, ['Black', 'Schwarz']],
          [/^(weiss(?:e|en|er|es|em)?|white)$/, ['White', 'Weiß', 'Weiss']],
          [/^(blau(?:e|en|er|es|em)?|blue)$/, ['Blue', 'Blau', 'blau', 'Navy']],
          [/^navy$/, ['Navy']],
          [/^(gruen(?:e|en|er|es|em)?|green)$/, ['Green', 'Grün', 'Grun']],
          [/^(braun(?:e|en|er|es|em)?|brown)$/, ['Brown', 'Braun']],
          [/^(grau(?:e|en|er|es|em)?|grey|gray)$/, ['Grey', 'Gray', 'Grau']],
          [/^(pink(?:e|en|er|es|em)?|rosa)$/, ['Pink', 'Rosa']],
          [/^(orange|orangen|oranger|oranges|orangem)$/, ['Orange']],
          [/^(beige|beigen|beiger|beiges|beigem)$/, ['Beige']],
          [/^(lila|violett(?:e|en|er|es|em)?|violet|purple)$/, ['Lila', 'Violet', 'Violett', 'Purple']]
        ];
        const words = normalize(term).split(' ');
        const matches = colors.filter(([pattern]) => words.some((word) => pattern.test(word)));
        if (matches.length !== 1) return null;
        const [pattern, values] = matches[0];
        const filler = new Set(['ich', 'suche', 'ein', 'eine', 'einen', 'bitte', 'in', 'der', 'die', 'das', 'farbe', 'fuer', 'damen']);
        const categoryTerm = words.filter((word) => !pattern.test(word) && !filler.has(word)).join(' ');
        const category = this.categories.find((entry) => entry.aliases.some((alias) => normalize(alias) === categoryTerm));
        const collectionUrl = categoryTerm ? category?.url : this.dataset.allProductsUrl;
        if (!collectionUrl) return null;
        const url = new URL(collectionUrl, location.origin);
        if (url.origin !== location.origin) return null;
        values.forEach((value) => url.searchParams.append('filter.p.m.mm-google-shopping.color', value));
        return url;
      }

      redirectColorSearch() {
        const currentUrl = new URL(location.href);
        if (currentUrl.pathname !== new URL(this.form.action).pathname) return;
        const term = this.normalizeTerm(currentUrl.searchParams.get('q') || '');
        const filteredUrl = this.colorCategoryUrl(term);
        if (!filteredUrl) return;
        currentUrl.searchParams.forEach((value, key) => {
          if (key.startsWith('filter.') && key !== 'filter.p.m.mm-google-shopping.color') {
            filteredUrl.searchParams.append(key, value);
          }
        });
        location.replace(filteredUrl.href);
      }

      search() {
        if (this.suppressFocus || this.composing) return;
        this.cancel();
        const term = this.normalizeTerm(this.input.value);
        if (!term) {
          this.results.replaceChildren();
          this.close();
          return;
        }
        const filteredUrl = this.colorCategoryUrl(term);
        const link = filteredUrl || new URL(this.form.action);
        if (!filteredUrl) {
          link.searchParams.set('q', term);
          link.searchParams.set('options[unavailable_products]', 'show');
        }
        this.all.href = link.href;
        const visibleServices = this.matchingServices(term);
        this.services.forEach((service) => {
          service.hidden = !visibleServices.includes(service);
        });
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        if (this.isBlockedSearch(term)) {
          this.services.forEach((service) => { service.hidden = true; });
          this.message(this.dataset.empty);
          return;
        }
        if (visibleServices.length) {
          this.results.replaceChildren();
          this.status.textContent = visibleServices.map((service) => service.textContent).join(', ');
        }
        if (term.length < 2) {
          this.results.replaceChildren();
          return;
        }
        this.message(this.dataset.loading);
        this.results.setAttribute('aria-busy', 'true');
        const sequence = this.sequence;
        this.timer = setTimeout(async () => {
          const request = new AbortController();
          this.request = request;
          this.deadline = setTimeout(() => request.abort(), 8000);
          const url = filteredUrl ? new URL(filteredUrl) : new URL(this.dataset.endpoint, location.origin);
          url.searchParams.set('section_id', filteredUrl ? 'kf-filtered-search' : 'kf-predictive-search');
          if (!filteredUrl) {
            url.searchParams.set('q', term);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('resources[options][unavailable_products]', 'show');
            url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku');
          }
          try {
            const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Search unavailable');
            const markup = await response.text();
            if (sequence !== this.sequence || !this.isConnected) return;
            const parsed = new DOMParser().parseFromString(markup, 'text/html');
            const list = parsed.querySelector('[data-kf-search-items]');
            if (!list) throw new Error('Search response incomplete');
            if (filteredUrl && list.dataset.kfColorFilter !== 'true' && list.dataset.kfResultCount !== '0') throw new Error('Color filter unavailable');
            const count = list.querySelectorAll('.kf-search__product').length;
            if (count) {
              const phrase = this.normalizeServiceTerm(term);
              const titleMatch = phrase && [...list.querySelectorAll('[data-kf-product-title]')].some((product) =>
                (' ' + this.normalizeServiceTerm(product.dataset.kfProductTitle) + ' ').includes(' ' + phrase + ' ')
              );
              if (titleMatch) this.services.forEach((service) => { service.hidden = true; });
              this.results.replaceChildren(list);
              this.status.textContent = count + ' ' + this.dataset.resultsLabel;
            } else if (visibleServices.length) {
              this.results.replaceChildren();
              this.status.textContent = visibleServices.map((service) => service.textContent).join(', ');
            } else {
              this.message(this.dataset.empty);
            }
          } catch (error) {
            if (sequence === this.sequence && this.isConnected) this.message(this.dataset.error);
          } finally {
            if (sequence === this.sequence) {
              clearTimeout(this.deadline);
              this.request = null;
              this.results.removeAttribute('aria-busy');
            }
          }
        }, 250);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    function initKfCollectionColorCounts() {
  if (!['template-collection', 'template-search'].some(name => document.body.classList.contains(name))) return;
  const root = document.getElementById('content');
  if (!root || root.hasAttribute('data-kf-color-count-observer')) return;
  root.setAttribute('data-kf-color-count-observer', '');
  const pending = new Set();
  let scheduled = false;

  function update(card) {
    const label = card.querySelector('.kf-color-count');
    if (!label) return;
    const groups = Array.from(card.querySelectorAll('variant-swatch-king [option-name]'))
      .filter(group => /^(farbe|color|colour|couleur|kleur)$/i.test(group.getAttribute('option-name').trim()));
    const colors = new Map();
    for (const group of groups) {
      for (const item of group.querySelectorAll('.swatch-view-item')) {
        if (item.hidden || item.getAttribute('aria-disabled') === 'true' || item.hasAttribute('disabled') ||
            item.classList.contains('star-hide') || getComputedStyle(item).display === 'none') continue;
        const swatch = item.querySelector('[swatch-url]');
        if (!swatch) continue;
        const name = (swatch.getAttribute('data-value') || item.getAttribute('orig-value') || '').trim();
        const value = name || swatch.getAttribute('swatch-url');
        if (value) colors.set(value.trim().toLocaleLowerCase(), name);
      }
      group.setAttribute('data-kf-color-count-source', '');
    }
    const count = Math.max(0, colors.size - 1);
    const template = count === 1 ? label.dataset.colorCountOne : label.dataset.colorCountOther;
    const singleColor = colors.size === 1 ? colors.values().next().value : '';
    const text = count > 0 && template ? template.replaceAll('__count__', String(count)) :
      singleColor && label.dataset.colorLabel ? `${label.dataset.colorLabel}: ${singleColor}` : '';
    if (label.textContent !== text) label.textContent = text;
    if (label.hidden !== !text) label.hidden = !text;
  }

  function queue(card) {
    if (!card || !card.isConnected) return;
    pending.add(card);
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      const cards = Array.from(pending);
      pending.clear();
      cards.forEach(update);
    });
  }

  new MutationObserver(records => {
    for (const record of records) {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      if (target?.closest('.kf-color-count')) continue;
      queue(target?.closest('product-block'));
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('product-block')) queue(node);
        node.querySelectorAll('product-block').forEach(queue);
      }
    }
  }).observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled', 'swatch-url']
  });
  root.querySelectorAll('product-block').forEach(queue);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKfCollectionColorCounts, { once: true });
} else {
  initKfCollectionColorCounts();
}
  } catch(e) { console.error(e); }
})();

})();
